const getAllowedTracingOrigins = () => {
  const allowedTracingOrigins = process.env.VUE_APP_DATADOG_ALLOWED_TRACING_ORIGINS
  return allowedTracingOrigins ? allowedTracingOrigins.split(',') : []
}

export const getDatadogRumConfiguration = () => {
  const allowedTracingOrigins = getAllowedTracingOrigins()
  const applicationId = process.env.VUE_APP_DATADOG_RUM_APPLICATION_ID
  const clientToken = process.env.VUE_APP_DATADOG_RUM_CLIENT_TOKEN
  const env = process.env.VUE_APP_DATADOG_RUM_ENV
  const service = process.env.VUE_APP_DATADOG_RUM_SERVICE
  const site = process.env.VUE_APP_DATADOG_RUM_SITE

  if (applicationId && clientToken) {
    return {
      allowedTracingOrigins,
      applicationId,
      clientToken,
      site,
      service,
      env
    }
  } else {
    // If Datadog is not yet setup for this environment, we shouldn't
    // create a configuration at all to prevent Datadog RUM from trying
    // to be loaded.
    return null
  }
}
